module.exports = __webpack_public_path__ + "static/media/R3L3-right.77416c97.svg";